import { render, staticRenderFns } from "./CardProcessDetails.vue?vue&type=template&id=38e4df4c&"
import script from "./CardProcessDetails.vue?vue&type=script&lang=js&"
export * from "./CardProcessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports